import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { IDropdownType } from "app/dropdowns/dropdown.model";


@Component({
  selector: "app-add-types",
  templateUrl: "./add-types.component.html",
  styleUrls: ["./add-types.component.scss"],
})

export class AddTypesComponent implements OnInit {
  typeForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDropdownType,
    readonly formBuilder: FormBuilder,
    readonly dialogRef: MatDialogRef<AddTypesComponent>) {
    this.typeForm = this.formBuilder.group({
      type: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    console.log('this.data: ', this.data);
    if(this.data?.id){
      this.typeForm.patchValue({ type: this.data.name })
    }
  }

  /**
   * on submit
   */
  submit() {
    this.dialogRef.close(this.typeForm.get("type").value);
  }

  /**
   * on cancel
   */
  cancel() {
    this.dialogRef.close();
  }

     /**
   *  to check any change on edit
   */
     get isEdited() {
      return (
         this.data?.name !== this.typeForm.get("type").value
      );
    }

}
